import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RouletteAppContainer from '~/componentsPage/Roulette/RouletteAppContainer';

function Roulette() {
  const location = useLocation();
  const navigate = useNavigate();
  const { name, gender } = (location.state || {}) as { name?: string; gender?: string };

  useEffect(() => {
    if (name && gender) {
      window.history.replaceState({}, document.title);
    } else {
      navigate('/');
    }
  }, [name, gender, navigate]);

  return (
    <div data-page="Roulette" className="roulette">
      <RouletteAppContainer />
    </div>
  );
}

export default Roulette;
